/* ==========================================================================
   collection.js — collection page interactions
   - Mobile filter drawer open/close
   - Active state for concern pills (visual only, no real filtering)
   ========================================================================== */

(() => {
  'use strict';

  const sidebar = document.querySelector('[data-filter-sidebar]');
  const openBtn = document.querySelector('[data-filter-open]');
  const closeBtns = document.querySelectorAll('[data-filter-close]');

  if (!sidebar) return;

  // Inject a backdrop once
  const backdrop = document.createElement('div');
  backdrop.className = 'filter-backdrop';
  document.body.appendChild(backdrop);

  const openDrawer = () => {
    sidebar.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    sidebar.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  closeBtns.forEach((btn) => btn.addEventListener('click', closeDrawer));
  backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Concern pill visual active-state toggle (no real filtering for prototype)
  const pills = document.querySelectorAll('.concern-pill');
  const pillScroller = document.querySelector('.concern-pills__inner');
  const scrollPillIntoView = (pill) => {
    if (pillScroller && pill) {
      pill.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  };
  pills.forEach((pill) => {
    pill.addEventListener('click', (e) => {
      e.preventDefault();
      pills.forEach((p) => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      scrollPillIntoView(pill);
    });
  });
  // Scroll active pill into view on load
  const activePill = document.querySelector('.concern-pill.is-active');
  if (activePill) scrollPillIntoView(activePill);

  // Sticky offset + shadow for concern pill bar
  const pillBar = document.querySelector('.concern-pills');
  if (pillBar) {
    // Update --sticky-offset to match header bottom
    const updateStickyOffset = () => {
      const header = document.querySelector('.site-header');
      if (header) {
        const bottom = header.getBoundingClientRect().bottom;
        pillBar.style.setProperty('--sticky-offset', bottom + 'px');
      }
    };
    updateStickyOffset();
    window.addEventListener('scroll', updateStickyOffset, { passive: true });
    window.addEventListener('resize', updateStickyOffset, { passive: true });

    // Shadow when stuck
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;width:1px;position:absolute;pointer-events:none;';
    pillBar.parentNode.insertBefore(sentinel, pillBar);
    const obs = new IntersectionObserver(
      ([entry]) => pillBar.classList.toggle('is-stuck', !entry.isIntersecting),
      { threshold: 0 }
    );
    obs.observe(sentinel);
  }
})();
